const copilot = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 200 200"><rect width="100" height="200"/></svg>',
};

export { copilot as default };
